export default __webpack_public_path__ + "static/media/ISO 45K 2027.351c2dda.png";